import { Sidebar } from 'semantic-ui-react';
import styled from 'styled-components';
import { breakpoints } from '../../constants/responsive';

export const Pushable = styled(Sidebar.Pushable)<{ isCollapsed?: boolean }>`
  position: relative;

  .pusher {
    position: relative;
    overflow: initial !important;
  }

  .ui.left.visible.sidebar,
  .ui.right.visible.sidebar {
    box-shadow: none !important;

    @media (max-width: ${breakpoints.mobile}px) {
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15) !important;
    }
  }

  .ui.visible.left.sidebar~.fixed, 
  .ui.visible.left.sidebar~.pusher {
    transform: translateX(${props => props.isCollapsed ? sideBarCollapsedWidth : sideBarWidth}) !important;
    transition: transform 0.3s ease !important;

    @media (max-width: ${breakpoints.mobile}px) {
      transform: translateX(0) !important; /* Em mobile, não desloca o conteúdo */
    }
  }
`;

const sideBarWidth = '268px';
const sideBarCollapsedWidth = '70px';

export const NavbarContainer = styled.div`
  width: 100%;

  @media (max-width: ${breakpoints.mobile}px) {
    position: sticky;
    top: 0;
    z-index: 5;
    background-color: #fff;
  }
`;

export const ContentContainer = styled.div<{ isCollapsed?: boolean }>`
  height: calc(100vh - 2px);
  width: 100%;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: calc(100% - ${props => props.isCollapsed ? sideBarCollapsedWidth : sideBarWidth});
  margin-top: 2px;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling no iOS */

  @media (max-width: ${breakpoints.mobile}px) {
    max-width: 100%;
    height: calc(100vh - 60px); /* Ajusta pela altura da navbar */
  }

  @media (max-width: ${breakpoints.small}px) {
    height: calc(100vh - 56px);
  }
`;

export const Content = styled.div`
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 2em 2em 8em 2em;

  @media (max-width: ${breakpoints.mobile}px) {
    padding: 1em;
    padding-bottom: 4em;

    &.fire-insurance-budget-mobile-content {
      padding: 0;
    }
  }

  @media (max-width: ${breakpoints.small}px) {
    padding: 0.8em;
    padding-bottom: 3em;
  }
`;

export const SidebarPusher = styled(Sidebar.Pusher)``;

export const SidebarWrapper = styled(Sidebar)<{ isCollapsed?: boolean }>`
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 10;
  width: ${props => props.isCollapsed ? sideBarCollapsedWidth : sideBarWidth} !important;
  transition: width 0.3s ease;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling no iOS */

  @media (max-width: ${breakpoints.mobile}px) {
    z-index: 1000; /* Garante que fica acima de tudo em mobile */
    width: 280px !important;
  }

  @media (max-width: ${breakpoints.small}px) {
    width: 260px !important;
  }

  @media (max-width: ${breakpoints.extraSmall}px) {
    width: 240px !important;
  }
`;
